function CanMeet() {
  return (
    <div className="flex">
      <div className="bg-etcWord font-bold text-xs w-[70px] h-4 text-center rounded-lg m-1 leading-4">
        직거래가능
      </div>
    </div>
  );
}

export default CanMeet;
